import { render, staticRenderFns } from "./AgentTransactionsReportLawMatterList.vue?vue&type=template&id=8af24dea&"
import script from "./AgentTransactionsReportLawMatterList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportLawMatterList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportLawMatterList.vue?vue&type=style&index=0&id=8af24dea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports